/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlarmRealTimePaginatedList } from '../../models/alarm-real-time-paginated-list';
import { AlarmSearchBodyV2 } from '../../models/alarm-search-body-v-2';
import { AlarmSortFieldName } from '../../models/alarm-sort-field-name';
import { SortDirection } from '../../models/sort-direction';

export interface GetStationAlarmsSearch$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;
  sortFieldName?: AlarmSortFieldName;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search alarm
     */
    body?: AlarmSearchBodyV2
}

export function getStationAlarmsSearch(http: HttpClient, rootUrl: string, params: GetStationAlarmsSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<AlarmRealTimePaginatedList>> {
  const rb = new RequestBuilder(rootUrl, getStationAlarmsSearch.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlarmRealTimePaginatedList>;
    })
  );
}

getStationAlarmsSearch.PATH = '/stations/{uid}/alarms/search';
